import Typography from '@mui/material/Typography';

import { ensureDefined } from '@e-socna/utils';

import { ResolvableBoolean } from '../../ResolvableFields/ResolvableBoolean';
import type { ResolvableFieldSettings } from '../../ResolvableFields/types/resolvable-field-settings.type';

import { buildDisplayParameters } from './utils/build-display-parameters.util';
import type { ServiceUsageCardCmp_ResolvableServiceUsage } from './fragments/resolvable-service-usage.fragment';

interface Props {
  readonly resolvableFieldSettings: Partial<ResolvableFieldSettings>;
  readonly serviceUsage: ServiceUsageCardCmp_ResolvableServiceUsage;
}

export const ResolvableServiceUsageQuotationSettings = ({
  resolvableFieldSettings,
  serviceUsage,
}: Readonly<Props>) => {
  const {
    settings: {
      showAmountsInQuotation,
      showCostsInQuotation,
      showMaterialsInQuotation,
      showQuantitiesInQuotation,
    },
  } = ensureDefined({ settings: serviceUsage.settings });

  const parameters = buildDisplayParameters(resolvableFieldSettings);

  return (
    <>
      <Typography color="text.secondary" variant="overline">
        Paramètres Devis
      </Typography>
      <Typography component="div" gutterBottom variant="body2">
        Affichage des Montants dans le Devis :{' '}
        <ResolvableBoolean
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableBoolean={showAmountsInQuotation}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
        />
      </Typography>
      <Typography component="div" gutterBottom variant="body2">
        Affichage des Quantités dans le Devis :{' '}
        <ResolvableBoolean
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableBoolean={showQuantitiesInQuotation}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
        />
      </Typography>
      <Typography component="div" gutterBottom variant="body2">
        Affichage des Coûts Liés :{' '}
        <ResolvableBoolean
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableBoolean={showCostsInQuotation}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
        />
      </Typography>
      <Typography component="div" gutterBottom variant="body2">
        Affichage des Matériaux Liés :{' '}
        <ResolvableBoolean
          PrimaryWrapper={parameters.PrimaryWrapper}
          SecondaryWrapper={parameters.SecondaryWrapper}
          resolvableBoolean={showMaterialsInQuotation}
          resolvableFieldSettings={parameters.resolvableFieldSettings}
        />
      </Typography>
    </>
  );
};
